<!--
 * @Author: your name
 * @Date: 2020-08-13 20:08:41
 * @LastEditTime: 2022-10-31 13:53:12
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/OrderNumber/index.vue
-->
<style scoped lang="sass">
.order_box
  display: flex
  justify-content: center
  align-items: center

  .order_number
    display: flex
    align-content: center
    justify-content: center
    flex-direction: column
    padding: 15px 17px 12px 17px
    border: 1px solid #f1f2f3
    border-radius: 5px
    color: var(--menu-primary-background-colour) !important
    font-size: 30px
    line-height: 52px
    font-weight: bold

    .order_no
      text-align: center

  .time
    font-size: 10px
    color: var(--menu-primary-text-colour) !important
    line-height: 12px
    text-align: center
    font-weight: 400
</style>

<template lang="pug">
.order_box
  span.order_number
    span.order_no {{ '#' }}{{ orderNo | filterOrderNo }}
    span.time.o.ls3 {{ formattedTime }}
    span.order_status(v-if="orderStatusUrl.length > 0")
      van-button.view_menu.b.ls1(@click="gotoURL" round type="primary" block) {{ viewOrderStatusText }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/fr'
import { _DateFilters } from 'utils/format'
import { t, getDayjsLocale } from '@/utils/language'

@Component({
  props: {
    orderNo: [String, Number],
    createdAt: [String, Number],
    orderStatusUrl: {
      type: String,
      default: ''
    }
  },

  computed: {
    viewOrderStatusText() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return t('view_order_status', 'VIEW ORDER STATUS')
    },

    // Formatted time with locale support / 带语言支持的格式化时间
    formattedTime() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      const locale = getDayjsLocale()
      const val = this.createdAt
      const atText = t('time_at', 'at')
      return _DateFilters(val) + ` ${atText} ` + dayjs(val).locale(locale).format('hh:mmA')
    },
  },

  filters: {
    //  Filter the order number, keep the content after _
    // 过滤订单号码，保留 _ 后内容
    filterOrderNo(val) {
      const list = String(val).split('_')
      return list[list.length - 1]
    },
  }
})
class OrderNumber extends Vue {
  gotoURL() {
    this.$router.push({
      path: this.orderStatusUrl,
      query: {
        orderNo: this.orderNo,
      },
    })
  }
}

export default OrderNumber
</script>
